import {
  dedupeVerseTuples,
  verseKeyToTuple,
  verseTupleToKey,
} from './canonical_verse_utils';

export const MAX_VERSES_PER_DECK_CHUNK = 1000;

export function toVerseKeys(tuples) {
  return tuples.map(verseTupleToKey);
}

export function fromVerseKeys(verseKeys) {
  if (!Array.isArray(verseKeys)) {
    throw new TypeError('Stored verse keys must be an array');
  }
  return verseKeys.map(verseKeyToTuple);
}

export function collectDeckBookNumbers(tuples) {
  return [...new Set(tuples.map(([bookNumber]) => bookNumber))]
    .sort((first, second) => first - second);
}

export function serializeDeckVerseChunks(
  tuples,
  maxVersesPerChunk = MAX_VERSES_PER_DECK_CHUNK
) {
  if (!Array.isArray(tuples)) {
    throw new TypeError('Deck verses must be an array');
  }
  if (
    !Number.isInteger(maxVersesPerChunk)
    || maxVersesPerChunk < 1
    || maxVersesPerChunk > MAX_VERSES_PER_DECK_CHUNK
  ) {
    throw new RangeError(
      `Deck chunk size must be an integer from 1 to ${MAX_VERSES_PER_DECK_CHUNK}`
    );
  }

  const verses = dedupeVerseTuples(tuples);
  const chunks = [];
  for (let index = 0; index < verses.length; index += maxVersesPerChunk) {
    const chunkVerses = verses.slice(index, index + maxVersesPerChunk);
    const order = chunks.length;
    chunks.push({
      id: String(order).padStart(4, '0'),
      order,
      verse_count: chunkVerses.length,
      verse_keys: toVerseKeys(chunkVerses),
    });
  }
  return chunks;
}

export function deserializeDeckVerseChunks(chunks) {
  if (!Array.isArray(chunks)) {
    throw new TypeError('Deck chunks must be an array');
  }

  const orderedChunks = [...chunks].sort((first, second) => first.order - second.order);
  const tuples = [];
  orderedChunks.forEach((chunk, index) => {
    if (!chunk || chunk.order !== index) {
      throw new RangeError(`Deck chunk order must be contiguous from 0; missing order ${index}`);
    }
    const chunkTuples = fromVerseKeys(chunk.verse_keys);
    if (chunk.verse_count !== chunkTuples.length) {
      throw new RangeError(
        `Deck chunk ${chunk.order} declares ${chunk.verse_count} verses but stores ${chunkTuples.length}`
      );
    }
    if (chunkTuples.length > MAX_VERSES_PER_DECK_CHUNK) {
      throw new RangeError(
        `Deck chunk ${chunk.order} exceeds ${MAX_VERSES_PER_DECK_CHUNK} verses`
      );
    }
    tuples.push(...chunkTuples);
  });
  return dedupeVerseTuples(tuples);
}
